<template>
  <div>
    <textarea v-bind="inputAttrs" v-model="value">{{ value }}</textarea>

    <hr />
    <form-input
      type="checkbox"
      label="core.form.textAreaWithJson.isJson"
      v-model="isJson"></form-input>
    <div class="flex gap-m">
      <span
        v-show="isJson"
        :class="{ 'c-success': isValidJson, 'c-error': !isValidJson }">
        {{
          isValidJson
            ? t("core.form.textAreaWithJson.jsonIsValid")
            : t("core.form.textAreaWithJson.jsonIsInvalid")
        }}
      </span>
      <span
        v-if="hasCharacterCounter"
        class="character-counter"
        style="display: block">
        {{
          translate("core.form.characterLimit", {
            current: currentCharacters,
            max: maxCharacters,
          })
        }}
      </span>
    </div>
  </div>
</template>

<script>
import textAreaInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/input/textAreaInput.js";

export default {
  mixins: [textAreaInputMixin],
  props: {},
  data: function () {
    return {
      uid: utilities.getUniqueNumber(),
      isJson: false,
    };
  },
  computed: {
    value: {
      get() {
        if (this.modelValue && typeof this.modelValue === "object") {
          return JSON.stringify(this.modelValue);
        }
        return this.modelValue;
      },
      set(value) {
        let updatedValue = value;
        try {
          if (this.isJson && typeof value === "string") {
            updatedValue = JSON.parse(value);
          } else {
            updatedValue = String(value);
          }
        } catch (e) {
          console.log("invalid json");
        }

        this.$emit("update:modelValue", updatedValue);
        this.$nextTick(() => {
          try {
            this.internalCharacterCounter.current = this.modelValue.length;
          } catch (e) {}
        });
      },
    },
    isValidJson() {
      try {
        let parsed = JSON.parse(this.value);
        if (parsed) {
          return true;
        }
      } catch (e) {
        // we show UI info for the user over this, that is the handling
      }

      return false;
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newVal) {
        if (newVal && typeof newVal === "object") {
          this.isJson = true;
        }
      },
    },
  },
};
</script>
